import { List, Record } from 'immutable';

import config from '../config';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const DefaultTutorialState = new Record({
    tutorials: config.get('tutorials'),
    dismissed: new List()
});

export class TutorialStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.TUTORIAL_TOGGLE]: this.handleTutorialToggle
        };
    }

    validateStoredData ({ data }) {
        return Array.isArray(data.dismissed);
    }

    deserialize (serialized) {
        if (serialized) {
            return new DefaultTutorialState({ dismissed: new List(serialized.dismissed) });
        }
        return new DefaultTutorialState();
    }

    serialize () {
        return {
            dismissed: this.state.dismissed.toJS()
        };
    }

    handleTutorialToggle ({ tutorialName, open, dismissed }) {
        if (!dismissed && !open) {
            this.setState(this.state.set('dismissed', this.state.dismissed.filterNot(name => name === tutorialName)));
        } else if (dismissed && !open) {
            this.setState(this.state.set('dismissed', this.state.dismissed.push(tutorialName).toSet().toList()));
        }
    }

    getTutorialByName (tutorialName) {
        return this.state.get('tutorials').find((tutorial) => {
            return tutorial.name === tutorialName;
        });
    }

    isTutorialDismissed (tutorialName) {
        return this.state.get('dismissed').includes(tutorialName);
    }
}

const storeInstance = new TutorialStore({ storageKey: 'tutorial' });

export default storeInstance;
